import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { EditPopup } from '../.././shared/edit-popup';
import { SharedService } from '../.././shared/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { DispatchBoardService } from '../../dispatch/dispatchboard/dispatch-board.service';

import { techaddressparam, weekview, JobDetails, SmsLog, techaddress } from '../../dispatch/dispatchboard/dispatch-board.model';
import { FormControl, FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Severities } from '../../shared/shared.model';
import { AuthService } from '../../../authentication/auth.service';
import { API } from '../../core/app-config';
import { SmsLogReceived } from '../../work-order/work-order-models';

@Component({
    selector: 'sms-popup',
    templateUrl: 'sms-popup.html',
    providers: [DatePipe]
})
export class smsPopupComponent  implements OnInit, EditPopup {
    @Output() done = new EventEmitter();
    // @Input('rightsAccess') rights: boolean = false;
    // @Input() technician: weekview = new weekview();
    // @Input() techid: number;
    // @Input() jobid: number;
    // @Input() schdate: Date;
    // @Input() loginid: number;
    // @Input() custaddress: techaddress;
    @Input() smsmsvalue: SmsLogReceived;
    @Input()  CompanyId:number;
    @ViewChild("fileInput") fileInput;
    techparam: techaddressparam = new techaddressparam();
    acceptTypes: string;
    frmsms: FormGroup;
    jobdetails: JobDetails;
    fileName: string;
    url: string;
     smsdetails:any;
     tonumbercheck:boolean;
     descriptioncheck:boolean;
    constructor(private sharedService: SharedService, private authService: AuthService, private datePipe: DatePipe, private translate: TranslateService, private dispatchService: DispatchBoardService, private formBuilder: FormBuilder) {

    }
    ngOnInit() {
       
        debugger;
        this.smsdetails=this.smsmsvalue;
       this.tonumbercheck=false;
       this.descriptioncheck=false;
        this.acceptTypes = "audio/*,.xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf,image/*,.mp4";
        // var data = this.technician;
        // var techniciandata = data.details.filter(x => x.techInfo.techid == this.techid)[0];
        // this.techparam.companyid = techniciandata.techInfo.CompanyId;
        // this.techparam.jobid = this.jobid;
        // this.techparam.scheduledate = new Date(this.schdate).toDateString();
        // this.techparam.techid = this.techid;
        // this.jobdetails = techniciandata.weekdays.filter(w => new Date(w.scheduledate).toDateString() == this.techparam.scheduledate)[0].jobdetails.filter(x => x.WoJobId == this.jobid)[0];
        // var jobs = this.jobdetails;
        // var addr = "";
        // this.techparam.scheduledate = new Date(jobs.ScheduleDate).toDateString();
        // if (typeof this.custaddress.AddressLine1 != "undefined") {
        //     addr = ((this.custaddress.phone1 != null && this.custaddress.phone1 != "") ? this.custaddress.phone1 + ", " : "") + this.custaddress.AddressLine1 + " " + ((this.custaddress.AddressLine2 != "" && this.custaddress.AddressLine2 != null) ? this.custaddress.AddressLine2 + ", " : "") + ((this.custaddress.UnitNo != "" && this.custaddress.UnitNo != null) ? this.custaddress.UnitNo + ", " : "") + this.custaddress.CityName + ", " + this.custaddress.StateShortName + ", " + this.custaddress.ZipCode + ", " + this.custaddress.CountryName;
        // }

        // // Added By Amalraj S 20Aug2018 Strat
        // if (this.jobdetails.JobStatusId == 5) {
        //     var schStartDate = this.datePipe.transform(this.jobdetails.ActualScheduleStartDateTime, 'short');
        //     var schEndDate = this.datePipe.transform(this.jobdetails.ActualScheduleEndDateTime, 'short');
        //     if (new Date(schStartDate.split(' ')[0]).getTime() < new Date(schEndDate.split(' ')[0]).getTime()) {
        //         this.jobdetails.ScheduleSlot = schStartDate + ' - ' + schEndDate;
        //     }
        //     else {
        //         var e = schEndDate.split(' ')[2] ? schEndDate.split(' ')[2] : '';
        //         this.jobdetails.ScheduleSlot = schStartDate + " - " + schEndDate.split(' ')[1] + ' ' + e;
        //     }
        // }
        // else {
        //     var schStartDate = this.datePipe.transform(this.jobdetails.ScheduleStartDateTime, 'short');
        //     var schEndDate = this.datePipe.transform(this.jobdetails.ScheduleEndDateTime, 'short');
        //     if (new Date(schStartDate.split(' ')[0]).getTime() < new Date(schEndDate.split(' ')[0]).getTime()) {
        //         this.jobdetails.ScheduleSlot = schStartDate + ' - ' + schEndDate;
        //     }
        //     else {
        //         var e = schEndDate.split(' ')[2] ? schEndDate.split(' ')[2] : '';
        //         this.jobdetails.ScheduleSlot = schStartDate + " - " + schEndDate.split(' ')[1] + ' ' + e;
        //     }
        // }
        // // Added By Amalraj S 20Aug2018 End
        // var bodyContent = jobs.WoJobId + " (" + jobs.WoNumber + ") " + this.jobdetails.ScheduleSlot + "  Customer: " + jobs.CustomerName + ", " + addr.replace(',/g', ' ') + ", Status: " + jobs.JobStatus;
        // var body = bodyContent.replace(/null,/g, '');

        // this.frmsms = this.formBuilder.group({
        //     txttechname: [techniciandata.techInfo.techname, Validators.required],
        //     txtphonenumber: [techniciandata.techInfo.phone1, Validators.required],
        //     txtaddress: [body, Validators.required]
        // });

        this.frmsms = this.formBuilder.group({
            txttechname: [this.smsdetails.DisplayName],
            txtphonenumber: [this.smsdetails.FromNumber, Validators.required],
            txtaddress: ['', Validators.required]
        });

    }
    // Close popup
    close(success?: boolean) {
        debugger;
        
        this.done.emit({ "key": "Sms", "value": success });
    }
    // Sent Sms
    onBeforeSend(event) {
        var ac_token = this.authService.getAuthorizationHeaderValue();
        event.xhr.setRequestHeader('Authorization', ac_token);
    }
    Save() {

        debugger;
        var multinumber = this.frmsms.value.txtphonenumber.split(";")
   if(this.frmsms.value.txtphonenumber=="" || this.frmsms.value.txtphonenumber==null)
   {
    this.tonumbercheck=true;

    if(this.frmsms.value.txtaddress=="" || this.frmsms.value.txtaddress==null)
   {
    this.descriptioncheck=true;
    return;

   }
   else{
    this.descriptioncheck=false;
   }
    return;

   }
   else{
    this.tonumbercheck=false;
   }
   if(this.frmsms.value.txtaddress=="" || this.frmsms.value.txtaddress==null)
   {
    this.descriptioncheck=true;
    return;

   }
   else{
    this.descriptioncheck=false;
   }
  
        // multinumber.forEach(curntnumber => {
        // if (multinumber.length > 1) {
        //     for (let curntnumber of multinumber) {
        this.acceptTypes = "image/*";
        debugger;
        let file: File = this.fileInput.files[0];
        var date = new Date()
        var path = (window.performance && window.performance.now && window.performance.timing && window.performance.timing.navigationStart ? window.performance.now() + window.performance.timing.navigationStart : Date.now()).toString();
        var model = new SmsLog();
        // model.companyid = this.techparam.companyid;
        model.companyid =this.CompanyId;;
        
        // model.loginid = this.loginid;
        model.jobstatusid = this.smsdetails.JobStatusId;
        model.smscontent = this.frmsms.value.txtaddress;
        model.tonumber = this.frmsms.value.txtphonenumber;
        // model.tonumber = this.frmsms.value.txtphonenumber;
        model.wojobid = this.smsdetails.wojobid;
        model.workorderid = this.smsdetails.WorkOrderid;


        if (file != null && typeof file != "undefined") {
            model.FileName = file.name;
            model.FilePath = path;


            this.url = API.DISPATCHBOARD + '/ManageMMSUploadFile?companyId=' + this.CompanyId + '&workorderId=' + this.smsdetails.workorderid + '&woJobid=' + this.smsdetails.wojobid + '&Tonumber=' + model.tonumber + '&Content=' + model.smscontent + '&Path=' + path + '&ToNumbers=' + this.frmsms.value.txtphonenumber;
        }
        else {
            this.url = API.DISPATCHBOARD + '/ManageMMSUploadFile?companyId=' + this.CompanyId+ '&workorderId=' + this.smsdetails.WorkOrderid + '&woJobid=' + this.smsdetails.wojobid + '&Tonumber=' + model.tonumber + '&Content=' + model.smscontent + '&Path=' + path + '&ToNumbers=' + this.frmsms.value.txtphonenumber;
        }

        this.dispatchService.SaveSmsLog(model).subscribe(s => {
            if (s.Message.MessageCode == "1001") {
                this.fileInput.upload();
                this.sharedService.notification.emit({ severity: Severities[s.Message.Severity], summary: this.translate.instant('SMS') + " " + this.translate.instant('SENTSUCCESSFULLY') });
            }
            else {
                this.sharedService.notification.emit({ severity: Severities[s.Message.Severity], summary: this.translate.instant('SMS') + " " + this.translate.instant(s.Message.MessageCode) });
            }
            if (s.Message.Severity == Severities.success) {
              //  this.done.emit({ "key": "Sms", "value": false });
            }
        });


    }
}